module.exports = __webpack_public_path__ + "img/Weapon_33.b4267519.png";